import { render, staticRenderFns } from "./authResetPassFields.vue?vue&type=template&id=b489d854&scoped=true"
import script from "./authResetPassFields.vue?vue&type=script&lang=js"
export * from "./authResetPassFields.vue?vue&type=script&lang=js"
import style0 from "./authResetPassFields.vue?vue&type=style&index=0&id=b489d854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b489d854",
  null
  
)

export default component.exports